// Admin sempre passa em tudo, sem excecao. "user" so' passa se a chave
// estiver em user.permissions (populado no login/refresh_token - ver
// backend/src/helpers/SerializeUser.ts). Ver constants/adminPermissions.js
// pro catalogo de chaves validas.
export const hasPermission = (user, key) =>
  user?.profile === "admin" || (user?.permissions || []).includes(key);

export const hasAnyPermission = (user) =>
  user?.profile === "admin" || (user?.permissions || []).length > 0;
